import {
  ONBOARD_VENDOR_INFO_ACTION,
  ONBOARD_VENDOR_VERIFY_ACTION,
} from "./types";

export const onBoardVendorInfoAction = (vid, token) => ({
  type: ONBOARD_VENDOR_INFO_ACTION,
  vid: vid,
  token: token,
});

export const onBoardVendorVerifyAction = (data) => ({
  type: ONBOARD_VENDOR_VERIFY_ACTION,
  payload: data,
});
